import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "COVID-19 cases have surged among prisoners in Pennsylvania's state prisons in recent weeks. The Department of Corrections has introduced several measures to stop the spread, including enhanced screening of inmates and people entering facilities, but those measures don't appear to have prevented the virus from spreading rapidly.";

const FOOTNOTE_TEXT =
  "The number of prisoner cases and tests have been revised to exclude those who tested positive while released on parole.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="main__container">
        <div>
          <Header
            headline="COVID-19 surges in state prisons"
            subtitle={SUBTITLE_TEXT}
          />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="The Marshall Project, Associated Press, Pennsylvania Department of Corrections"
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
